export const categories = [
    {
      name: "Ethnic Wear",
      icon: "👗",
      color: "from-purple-500 to-pink-500",
      bg: "bg-purple-50",
      link:"/product/mens"
    },
    {
      name: "Decor",
      icon: "🏺",
      color: "from-amber-500 to-orange-500",
      bg: "bg-amber-50",
      link:"/product/decor"
    },
    {
      name: "Sarees",
      icon: "🥻",
      color: "from-rose-500 to-pink-600",
      bg: "bg-rose-50",
      link:"/product/womens"
    },
    {
      name: "Mens",
      icon: "👔",
      color: "from-blue-500 to-indigo-500",
      bg: "bg-blue-50",
      link:"/product/mens"
    },
    {
      name: "Gifts",
      icon: "🎁",
      color: "from-green-500 to-teal-500",
      bg: "bg-green-50",
      link:"/product/personalized-gifts"
    },
    // {
    //   name: "Jewellery",
    //   icon: "💍",
    //   color: "from-yellow-400 to-amber-500",
    //   bg: "bg-yellow-50",
    // },
    {
      name: "Printed",
      icon: "🖨️",
      color: "from-violet-500 to-purple-600",
      bg: "bg-violet-50",
      link:"/product/printed"
    },
    {
      name: "Pooja",
      icon: "🪔",
      color: "from-orange-400 to-red-500",
      bg: "bg-orange-50",
      link:"/product/decor"
    },
  ]